// extracted by mini-css-extract-plugin
export default {"all":"Section_all__2tNVp","desktopOnly":"Section_desktopOnly__eKSbK","mobileOnly":"Section_mobileOnly__DZ4aW"};